import React, { useEffect, useState } from "react";
import SideImage from "../../Assets/SideImage.png";
import { Alert, Button, TextField } from "@mui/material";
import Footer from "../../Components/Footer";
import { Controller, useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { Login } from "./Helper";
import Navbar from "../../Components/Navbar";
import { useDispatch } from "react-redux";
import { setLogin } from "../../Redux/Feature/loginSlice";
import { setToken } from "../../Redux/Feature/tokenSlice";
import { BallTriangle } from "react-loader-spinner";
import api from "../../Utils/api";
import { roles } from "../../Utils/constants";

const Signin = ({ role }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [LoginError, setLoginError] = useState({
    open: false,
    msg: "",
  });
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  useEffect(() => {
    if (role == roles.client || role == roles.consultant || role == roles.vendor) {
      navigate("/dashboard")
    }
  }, [])

  const onSubmit = (data) => {
    setLoading(true);
    Login(data)
      .then((res) => {
        setLoading(false);
        if (res && res.data?.success) {
          dispatch(
            setLogin({ role: res.data?.role, permissions: res.data?.permissions, userId: res.data?.userId, isHybridConsultant: res.data?.isHybridConsultant ?? false })
          );
          if (res.data?.isHybridConsultant) api.defaults.headers['Role'] = roles.consultant;
          api.defaults.headers['Authorization'] = `Bearer ${res.data.result.access_token}`;
          localStorage.setItem("at", res.data.result.access_token);
          localStorage.setItem("rft", res.data.result.refresh_token);
          localStorage.setItem("userId", res.data.userId);
          dispatch(setToken(res.data.result.access_token));
          navigate("/dashboard");
          return;
        }
        if (res.response.status >= 400 && res.response.status <= 500) {
          setLoginError({
            open: true,
            msg:
              res.response.status === 403
                ? "Your account is not approved yet"
                : "Email or password is wrong",
          });
          return;
        }
        setLoginError({
          open: true,
          msg: "Something Went Wrong",
        });
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  return (
    <div className="flex flex-col min-h-screen">
      {loading ? (
        <div className="flex flex-col bg-gradient-to-r from-green-100 to-green-50 justify-center h-screen items-center">
          <BallTriangle
            height={100}
            width={100}
            radius={5}
            color="#4fa94d"
            ariaLabel="ball-triangle-loading"
            wrapperClass={{}}
            wrapperStyle=""
            visible={true}
          />
          <span className="mt-4 text-2xl text-green-700">Logging you in..</span>
        </div>
      ) : (
        <>
          <Navbar />
          <div className="grid md:grid-cols-2 gap-5 grow">
            <div className="bg-[#EDFDF9] flex items-center justify-center">
              <img src={SideImage} className="w-[80vh]" alt="side_image" />
            </div>
            <div className="flex items-center justify-center">
              <form className="w-96" onSubmit={handleSubmit(onSubmit)}>
                {LoginError.open && (
                  <Alert severity={"error"} className="mb-4">
                    {LoginError.msg}
                  </Alert>
                )}
                <div className="flex flex-col">
                  <Controller
                    control={control}
                    name="username"
                    rules={{ required: true }}
                    render={({ field }) => (
                      <TextField
                        label="Username / Email"
                        {...field}
                        onChange={(e) =>
                          field.onChange(e.target.value.toLowerCase())
                        }
                        fullWidth
                      />
                    )}
                  />
                  {errors.username ? (
                    <h4 className="text-red-600 text-xs pt-2 pb-2">
                      *Username is required
                    </h4>
                  ) : (
                    <div>
                      <br />
                    </div>
                  )}
                  <Controller
                    control={control}
                    name="password"
                    rules={{ required: true }}
                    render={({ field }) => (
                      <TextField
                        type="password"
                        label="Password"
                        fullWidth
                        {...field}
                        onChange={(e) => field.onChange(e.target.value)}
                      />
                    )}
                  />
                  {errors.password ? (
                    <h4 className="text-red-600 text-xs pt-2 pb-2">
                      *Password is required
                    </h4>
                  ) : (
                    <div></div>
                  )}
                  <Link
                    to={"/resetpassword"}
                    className="pt-3 font-semibold"
                    style={{ color: "#2EBAA3" }}
                  >
                    Forgot Password?
                  </Link>
                  <br />
                  <Button
                    type="submit"
                    variant="contained"
                    style={{ color: "#FFFFFF" }}
                    fullWidth
                  >
                    Signin
                  </Button>
                  <h4 className="pt-2">
                    Don't have an account?{" "}
                    <Link
                      to="/signup"
                      className="font-semibold cursor-pointer underline"
                      style={{ color: "#2EBAA3" }}
                    >
                      Register Here
                    </Link>
                  </h4>
                </div>
              </form>
            </div>
          </div>
          <Footer />
        </>
      )}
    </div>
  );
};

export default Signin;
